<ng-container *ngIf="templateSettings">
    <ng-container
        *ngIf="{
            templateConfiguration: templateConfiguration$ | async,
            evenTemplateConfiguration: evenTemplateConfiguration$ | async,
            firstTemplateConfiguration: firstTemplateConfiguration$ | async
        } as data"
    >
        <ng-container *ngIf="hasCmsStyles; else productTemplate">
            <div class="grid-{{ templateSettings.name }}-wrap" [ngStyle]="templateCmsStyles">
                <ng-container *ngTemplateOutlet="productTemplate"></ng-container>
            </div>
        </ng-container>

        <ng-template #productTemplate>
            <ul class="grid-product-wrap--{{ templateSettings.name }} {{ ulClasses }} {{ skeletonNoDetails }} wrap--{{ templateName }}">
                <li
                    *ngFor="let product of products; trackBy: trackByIndex; let even = even; let odd = odd; let first = first; let i = index"
                    class="
                        grid-product-list--{{ templateSettings.name }}
                        {{ liClasses }}
                        {{ first ? firstLiClasses : '' }}
                        {{ even ? evenLiClasses : '' }}
                        "
                >
                    <ng-container>
                        <product-view
                            class="p-view"
                            [config]="
                                first && templateSettings?.firstTemplateConfiguration
                                    ? data.firstTemplateConfiguration
                                    : even && templateSettings?.evenTemplateConfiguration
                                      ? data.evenTemplateConfiguration
                                      : data.templateConfiguration
                            "
                            [categoryConfig]="categoryConfiguration"
                            [productStyle]="productStyle"
                            [productId]="product"
                            [elementIndex]="i"
                            [defaultImageType]="elementDefaultImageTypes?.[product]"
                            (clickActionBadge)="addToCartSheet($event)"
                        ></product-view>
                    </ng-container>
                </li>
            </ul>
        </ng-template>
    </ng-container>
</ng-container>
